var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAuthGoogle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3035 12.24C22.3035 11.5646 22.2381 10.8675 22.1292 10.2139H12.6957V14.0701H18.0987C17.8809 15.3119 17.1619 16.4012 16.0944 17.0984L19.3188 19.6038C21.2142 17.8391 22.3035 15.2683 22.3035 12.24Z",
    fill: "#4280EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6959 22.0004C15.3974 22.0004 17.6632 21.1072 19.319 19.5821L16.0946 17.0985C15.2013 17.7085 14.0467 18.0571 12.6959 18.0571C10.0815 18.0571 7.88112 16.2924 7.07502 13.9395L3.76349 16.4885C5.46283 19.8654 8.90508 22.0004 12.6959 22.0004Z",
    fill: "#34A353"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07485 13.9174C6.66091 12.6756 6.66091 11.3248 7.07485 10.083L3.76332 7.51221C2.3472 10.3444 2.3472 13.6778 3.76332 16.4882L7.07485 13.9174Z",
    fill: "#F6B704"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6959 5.9655C14.112 5.94372 15.5064 6.48838 16.5303 7.46877L19.3843 4.59296C17.5761 2.89362 15.1796 1.97859 12.6959 2.00038C8.90508 2.00038 5.46283 4.13545 3.76349 7.51234L7.07502 10.0831C7.88112 7.70842 10.0815 5.9655 12.6959 5.9655Z",
    fill: "#E54335"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAuthGoogle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/auth_google.2cc245dd92940bc3416627cfca15a1da.svg";